import { FetchData } from "./const";

class DataService {

    private _data: FetchData;

    public constructor() { }

    public get data() { return this._data };

    public set data(value: FetchData) { this._data = value };
}

export const DATA_SERVICE = new DataService();